import React from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from 'global/components/alerts';
import { get } from 'global/lib/lodash';

export default (props) => {
  const { alerts, setAlerts } = props;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={!!alerts}
      autoHideDuration={6000}
      onClose={() => setAlerts()}
    >
      <Alert onClose={() => setAlerts()} severity={get(alerts, 'severity', 'success')}>
        <div dangerouslySetInnerHTML={{ __html: get(alerts, 'message', '') }}></div>
      </Alert>
    </Snackbar>
  );
};
